<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-01 16:24:50
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-12 17:20:50
 * @Description: 
-->
<template>
  <header
    class="landing-header lt-sm:border-white/10 lt-sm:bg-white/80 lt-sm:shadow-[0_4px_20px_rgba(0,0,0,0.05)] lt-sm:backdrop-blur-12px"
    :class="{ 'is-active': isScrolled || isMenuOpen }"
  >
    <div
      class="landing-container h-70px gap-16px lt-sm:h-130px lt-sm:px-24px flex items-center justify-between"
    >
      <a
        class="inline-flex items-center"
        href="#hero"
        aria-label="绘管家首页"
        @click="emitNavigate($event, 'hero')"
      >
        <img
          class="h-40px w-206px lt-sm:h-64px lt-sm:w-213px object-contain"
          src="/assets/img/huiguanjia-logo-web.png"
          alt="绘管家 HUIGUANJIA.CN"
        />
      </a>

      <nav id="huiguanjia-nav" class="gap-16px hidden items-center sm:flex" aria-label="主导航">
        <a
          v-for="item in standardNavItems"
          :key="item.id"
          class="h-40px font-s-14px inline-flex items-center justify-center rounded-full px-0 transition-all duration-200"
          :class="
            activeSection === item.id
              ? 'pf-sc-semibold w-92px bg-#eaf3ff text-#0f67f8'
              : 'pf-sc-regular w-92px text-#5f6f88 hover:text-#0f67f8'
          "
          :href="`#${item.id}`"
          :aria-current="activeSection === item.id ? 'true' : undefined"
          @click="emitNavigate($event, item.id)"
        >
          {{ item.label }}
        </a>
        <a
          class="pf-sc-semibold h-40px min-w-112px border-#1565f9 px-22px font-s-14px text-#1565f9 hover:-translate-y-1px hover:border-#0756d8 hover:text-#0756d8 inline-flex items-center justify-center rounded-full border bg-transparent transition-all duration-200"
          :href="backendLoginUrl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="登录绘管家后台"
        >
          登录后台
        </a>
        <a
          v-for="item in ctaNavItems"
          :key="item.id"
          class="pf-sc-semibold h-40px min-w-112px bg-#1565f9 px-26px font-s-14px hover:-translate-y-1px hover:bg-#0756d8 inline-flex items-center justify-center rounded-full text-white transition-all duration-200"
          :href="`#${item.id}`"
          :aria-current="activeSection === item.id ? 'true' : undefined"
          @click="emitNavigate($event, item.id)"
        >
          {{ item.label }}
        </a>
      </nav>

      <button
        class="menu-toggle-btn sm:hidden!"
        type="button"
        :aria-expanded="isMenuOpen"
        aria-controls="huiguanjia-mobile-nav"
        :aria-label="isMenuOpen ? '关闭导航菜单' : '打开导航菜单'"
        @click="toggleMenu"
      >
        <i v-if="isMenuOpen" class="i-ep-close lt-sm:wh-48px" aria-hidden="true"></i>
        <i v-else class="i-custom-menu lt-sm:wh-48px" aria-hidden="true"></i>
      </button>
    </div>
  </header>

  <div
    v-if="isMenuOpen"
    id="huiguanjia-mobile-nav"
    class="top-80px animate-fade-in-down lt-sm:top-128px lt-md:flex fixed inset-0 z-90 hidden flex-col overflow-hidden bg-white"
  >
    <nav class="lt-sm:px-24px lt-sm:py-20px flex-1 overflow-y-auto" aria-label="移动端主导航">
      <div class="pf-sc-semibold lt-sm:gap-8px lt-sm:font-s-30px text-#0f172a flex flex-col">
        <a
          v-for="item in standardNavItems"
          :key="item.id"
          class="mobile-nav-item lt-sm:py-16px flex items-center justify-between"
          :class="activeSection === item.id ? 'text-#0f67f8' : ''"
          :href="`#${item.id}`"
          :aria-current="activeSection === item.id ? 'true' : undefined"
          @click="emitNavigate($event, item.id)"
        >
          <span>{{ item.label }}</span>
        </a>
        <a
          class="mobile-nav-item lt-sm:py-16px flex items-center justify-between"
          :href="backendLoginUrl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="登录绘管家后台"
          @click="closeMenu"
        >
          <span>登录后台</span>
        </a>
        <a
          v-for="item in ctaNavItems"
          :key="item.id"
          class="mobile-nav-item lt-sm:py-16px flex items-center justify-between"
          :class="activeSection === item.id ? 'text-#0f67f8' : ''"
          :href="`#${item.id}`"
          :aria-current="activeSection === item.id ? 'true' : undefined"
          @click="emitNavigate($event, item.id)"
        >
          <span>{{ item.label }}</span>
        </a>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
  import { navItems } from '~/constants/huiguanjia-home'
  import siteConfig from '~/utils/constants'

  defineOptions({
    name: 'MHeader',
  })

  const { activeSection, isMenuOpen, isScrolled, scrollToSection } = useHuiguanjiaHomeContext()
  const standardNavItems = navItems.filter((item) => !item.cta)
  const ctaNavItems = navItems.filter((item) => item.cta)
  const backendLoginUrl = siteConfig.footerWrite.adminUrl || 'https://wy.huiguanjia.cn/login'

  const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
  }

  const closeMenu = () => {
    isMenuOpen.value = false
  }

  const emitNavigate = (event: MouseEvent, sectionId: string) => {
    event.preventDefault()
    scrollToSection(sectionId)
  }
</script>

<style scoped lang="scss">
  .landing-header {
    @apply backdrop-blur-10px ease fixed top-0 left-0 z-100 w-full border-b border-transparent bg-white/84 transition-all duration-300;
    @apply lt-sm:sticky;

    &.is-active {
      @apply backdrop-blur-12px border-white/60 bg-white/86 shadow-[0_4px_20px_rgba(0,0,0,0.05)];
    }
  }

  .menu-toggle-btn {
    @apply text-#334155 flex items-center justify-center border-0 bg-transparent p-0 lg:hidden;
  }

  .mobile-nav-item {
    @apply active:text-#0f67f8 border-b border-gray-100 transition-colors;
  }

  @keyframes fade-in-down {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fade-in-down {
    animation: fade-in-down 0.2s ease-out forwards;
  }
</style>
